import Insights from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/insights'

export default function MatchingInsightsMessage({
  insights_labels,
  overall_insights
}) {
  return (
    <div>
      <Insights
        labels={insights_labels}
        insights={{
          chances: overall_insights.insights.chances,
          risks: overall_insights.insights.risks,
          interviews: overall_insights.insights.interviews,
          measures: overall_insights.insights.measures
        }}
      />
    </div>
  )
}
